import React from 'react'
import { Route, Redirect } from 'react-router-dom'

import Details from '../../../containers/tabs/OrderDetailsModal/Details'
import More from '../../../containers/tabs/OrderDetailsModal/More'
import Void from '../../../containers/tabs/OrderDetailsModal/Void'
import Close from '../../../containers/tabs/OrderDetailsModal/Close'
import SplitOrder from '../../../containers/tabs/OrderDetailsModal/SplitOrder'
import SplitOrderByItems from '../../../containers/tabs/OrderDetailsModal/SplitOrderByItems'
import SplitOrderByDollar from '../../../containers/tabs/OrderDetailsModal/SplitOrderByDollar'
import SplitOrderByPercent from '../../../containers/tabs/OrderDetailsModal/SplitOrderByPercent'
import AdjustExemptions from '../../../containers/tabs/OrderDetailsModal/AdjustExemptions'
import AdjustPrice from '../../../containers/tabs/OrderDetailsModal/AdjustPrice'
import AdjustQuantity from '../../../containers/tabs/OrderDetailsModal/AdjustQuantities'
import CombineOrders from '../../../containers/tabs/OrderDetailsModal/CombineOrders'
import TransferCustomer from '../../../containers/tabs/OrderDetailsModal/TransferCustomer'
import Finalize from '../../../containers/tabs/OrderDetailsModal/Finalize'
import FinalizeTender from '../../../containers/tabs/OrderDetailsModal/FinalizeTender'
import ReceiptSelect from '../../../containers/tabs/OrderDetailsModal/ReceiptSelect'
import CloseTender from '../../../containers/tabs/OrderDetailsModal/CloseTender'
import SelectDiscount from '../../../containers/SelectDiscount'
import SelectNoOpPayment from '../../../containers/SelectNoOpPayment'

import OrderStates from '../../../utils/orderStates'

const ProtectedRoute = ({ children, accessAllowed, redirectPath, ...rest }) => {
  return (
    <Route
      {...rest}
      render={() => {
        return accessAllowed ? children : <Redirect to={redirectPath} />
      }}
    />
  )
}

const OrderDetailsModal = ({ orderId, orderState }) => {
  const isOpen = OrderStates.isOpen(orderState)
  const protectedRouteProps = {
    accessAllowed: isOpen,
    redirectPath: `/tabs/${orderId}`
  }

  return (
    <>
      <Route path="/tabs/:orderId" exact>
        <Details />
      </Route>
      <Route path="/tabs/:orderId/void">
        <Void />
      </Route>
      <Route path="/tabs/:orderId/receiptSelect">
        <ReceiptSelect />
      </Route>
      <ProtectedRoute {...protectedRouteProps} path="/tabs/:orderId/more">
        <More />
      </ProtectedRoute>
      <ProtectedRoute {...protectedRouteProps} path="/tabs/:orderId/close">
        <Close />
      </ProtectedRoute>
      <ProtectedRoute {...protectedRouteProps} path="/tabs/:orderId/split-order">
        <SplitOrder />
      </ProtectedRoute>
      <ProtectedRoute {...protectedRouteProps} path="/tabs/:orderId/split-by-items">
        <SplitOrderByItems />
      </ProtectedRoute>
      <ProtectedRoute {...protectedRouteProps} path="/tabs/:orderId/split-by-percent">
        <SplitOrderByPercent />
      </ProtectedRoute>
      <ProtectedRoute {...protectedRouteProps} path="/tabs/:orderId/split-by-dollar">
        <SplitOrderByDollar />
      </ProtectedRoute>
      <ProtectedRoute {...protectedRouteProps} path="/tabs/:orderId/adjust-exemptions">
        <AdjustExemptions />
      </ProtectedRoute>
      <ProtectedRoute {...protectedRouteProps} path="/tabs/:orderId/adjust-price">
        <AdjustPrice />
      </ProtectedRoute>
      <ProtectedRoute {...protectedRouteProps} path="/tabs/:orderId/adjust-quantities">
        <AdjustQuantity />
      </ProtectedRoute>
      <ProtectedRoute {...protectedRouteProps} path="/tabs/:orderId/combine">
        <CombineOrders />
      </ProtectedRoute>
      <ProtectedRoute {...protectedRouteProps} path="/tabs/:orderId/transfer-customer">
        <TransferCustomer />
      </ProtectedRoute>
      <ProtectedRoute {...protectedRouteProps} path="/tabs/:orderId/finalize">
        <Finalize />
      </ProtectedRoute>
      <ProtectedRoute {...protectedRouteProps} path="/tabs/:orderId/finalize-tender/:paymentId?">
        <FinalizeTender />
      </ProtectedRoute>
      <ProtectedRoute {...protectedRouteProps} path="/tabs/:orderId/close-tender/:paymentId?">
        <CloseTender />
      </ProtectedRoute>
      <ProtectedRoute {...protectedRouteProps} path="/tabs/:orderId/close/select-discount">
        <SelectDiscount />
      </ProtectedRoute>
      <ProtectedRoute {...protectedRouteProps} path="/tabs/:orderId/close/select-payment">
        <SelectNoOpPayment />
      </ProtectedRoute>
    </>
  )
}

export default OrderDetailsModal
